export default __webpack_public_path__ + "static/media/publicd.7a6fafdc.svg";